/* One consent-gated event after Shopify confirms a quote. No form payload. */
(function () {
  'use strict';
  var key = 'tt-quote-attempt';
  var form = document.getElementById('ContactForm');
  var success = document.querySelector('[data-tt-contact-success]');
  var sent = false;

  function permission() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return api && typeof api.analyticsProcessingAllowed === 'function'
        ? api.analyticsProcessingAllowed() : null;
    } catch (_) { return null; }
  }

  function clearAttempt() {
    try { sessionStorage.removeItem(key); } catch (_) {}
  }

  if (form && !success) {
    form.addEventListener('submit', function () {
      clearAttempt();
      if (permission() !== true || !form.querySelector('[data-type="quote"] input:checked')) return;
      try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {}
    });
  }

  function publishSuccess() {
    if (!success || sent) return;
    var allowed = permission();
    if (allowed === false) { clearAttempt(); return; }
    if (allowed !== true) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    var timestamp;
    try { timestamp = Number(sessionStorage.getItem(key)); } catch (_) { return; }
    if (!timestamp || Date.now() - timestamp < 0 || Date.now() - timestamp > 3600000) {
      clearAttempt();
      return;
    }
    // Consume before publishing: reload, back/forward, and consent events cannot duplicate it.
    sent = true;
    clearAttempt();
    try {
      var result = analytics.publish('quote_request_submitted', {});
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_) {}
  }

  publishSuccess();
  window.addEventListener('load', publishSuccess, { once: true });
  window.addEventListener('pageshow', publishSuccess);
  document.addEventListener('visitorConsentCollected', publishSuccess);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', publishSuccess);
})();
